import { HTTP } from '../http';

export default {
  search(params) {
    return HTTP.post('/file-types/search', params)
      .then((response) => response.data.data);
  },
};
